import { render, staticRenderFns } from "./EditEmploymentDetails.vue?vue&type=template&id=afbfe10e&scoped=true"
import script from "./EditEmploymentDetails.vue?vue&type=script&lang=js"
export * from "./EditEmploymentDetails.vue?vue&type=script&lang=js"
import style0 from "./EditEmploymentDetails.vue?vue&type=style&index=0&id=afbfe10e&prod&scoped=true&lang=css"
import style1 from "./EditEmploymentDetails.vue?vue&type=style&index=1&id=afbfe10e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbfe10e",
  null
  
)

export default component.exports